export const CCenteredCopyFragments = {
  field: `
    fragment centeredCopy on centeredCopy_MatrixField {
      ... on centeredCopy_block_Entry {
        id
        typeHandle
        idName
        heading
        copy
        notes
        showReferencesButton
      }
    }
  `,
}
